import { FC } from 'react'

import { Flight, RawTourFlight } from 'shared/api/tours/flights/model'
import { Loader } from 'shared/ui/loader'

import { FlightCard } from '../flight-card'

import { FlightListEmpty } from './components'
import s from './styles.module.scss'

interface FlightListProps {
  flights: Flight[]
  rawFlights: RawTourFlight[]
  isLoading: boolean
  error: boolean
}

export const FlightList: FC<FlightListProps> = ({
  flights,
  rawFlights,
  isLoading,
  error,
}) => {
  if (isLoading) {
    return (
      <div className={s.list}>
        <Loader />
      </div>
    )
  }

  if (!flights.length || error) {
    return <FlightListEmpty />
  }

  return (
    <div className={s.list}>
      {flights.map((flight, index) => (
        <FlightCard
          key={index}
          flight={flight}
          rawFlight={rawFlights[index]}
        />
      ))}
    </div>
  )
}
